import {
  ColumnLayout,
  Container,
  FormField,
  Header,
  Input,
  SpaceBetween,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

import { labelValuesShape } from './labelPdf';

/** Editable label fields, prefilled from the traveler and free to override. */
export default function LabelFieldsSection({ values, setFieldValue }) {
  return (
    <Container header={<Header variant="h2">Label fields</Header>}>
      <SpaceBetween size="m">
        <ColumnLayout columns={2}>
          <FormField label="Product name" stretch>
            <Input
              value={values.name}
              onChange={({ detail }) => setFieldValue('name', detail.value)}
            />
          </FormField>
          <FormField label="SKU" stretch>
            <Input
              value={values.sku}
              onChange={({ detail }) => setFieldValue('sku', detail.value)}
            />
          </FormField>
          <FormField label="Batch" description="YYYYMMDD-XXX, from the order date and line item sequence." stretch>
            <Input
              value={values.batch}
              onChange={({ detail }) => setFieldValue('batch', detail.value)}
            />
          </FormField>
          <FormField label="QR header" description="Text above the QR code, e.g. “Quick-Start”. Auto-filled from the product when set there." stretch>
            <Input
              value={values.qrHeader}
              onChange={({ detail }) => setFieldValue('qrHeader', detail.value)}
            />
          </FormField>
        </ColumnLayout>
        <FormField label="QR link" description="Leave empty to omit the QR code. Auto-filled from the product when set there." stretch>
          <Input
            value={values.qrValue}
            onChange={({ detail }) => setFieldValue('qrValue', detail.value)}
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
}

LabelFieldsSection.propTypes = {
  values: labelValuesShape.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};
